import { githubScenario } from './github'
import { selfMaintainedScenario } from './selfMaintained'
import type { Scenario } from './types'
import { weeklyScenario } from './weekly'

export const SCENARIOS: Scenario[] = [
  selfMaintainedScenario,
  weeklyScenario,
  githubScenario,
]
